import React from 'react';
const MainFooter = (props) => {
    const { selectedLanguage } = props
    return (
        <div className='frth-design-footer'>
            <div>
                <div className='frth-des-footer-left-side'>
                    <h2>
                        {selectedLanguage?.txt_about_us}
                    </h2>
                    <p>
                        {selectedLanguage?.txt_health_care_is_a_constant_form_of_collaboration_and_innovation}
                    </p>
                </div>
                <div className='frth-des-footer-right-side'>
                    <h2>
                        {selectedLanguage?.txt_contact_}
                    </h2>
                    <p>{selectedLanguage?.txt_3_taha_hussein_street} {selectedLanguage?.txt_el_yamama_center_zamalek_cairo}</p>
                    <p>0100 0066654</p>
                    <p>info@cairocapitalclinics.com</p>
                </div>
            </div>
        </div>
    )
}

export default MainFooter